<script setup lang="ts">
import sanitizeHtml from 'sanitize-html'
import { Employee, MediaImageFragment, ToccoSeminarFieldsFragment } from '~/api/graphql/generated'
const props = defineProps<{
  entity: ToccoSeminarFieldsFragment
}>()
const { t } = useI18n()

const employees = (props.entity.fieldResponsiblePersons ?? [])
  .map((item) => item?.entity as Employee | null)
  .filter((item): item is Employee => item != null)
  .map((item) => {
    return {
      id: item.id!,
      name: `${item.fieldAcademicTitle ?? ''} ${item.fieldFirstName} ${item.fieldLastName}`,
      email: item.fieldEmail ?? '',
      phone: item.fieldPhone ?? '',
      position: sanitizeHtml(item.fieldPosition?.[0]?.entity?.fieldWorkTitle ?? ''),
      description: item.fieldDescription ?? '',
      link: {
        url: item.entityUrl?.path || '',
        text: t('employee.list.teaser.cta'),
      },
      image: item.fieldImage?.entity as MediaImageFragment,
    }
  })
</script>

<template>
  <SectionSpecial v-if="employees.length" :title="t('tocco.detail.responsiblePersons')">
    <EmployeeList :employees="employees" />
  </SectionSpecial>
</template>
<style lang="scss" scoped>
.list {
  @media all and (min-width: get-breakpoint(t)) and (max-width: get-breakpoint(tl)) {
    margin-top: 48px;
  }
}

// Design (detail boards): a lone responsible-person card stretches across
// the full grid; with several persons the shared column grid stays.
:deep(.list > li:only-child) {
  grid-column: 1 / -1;
}
</style>
